import { DialogRef } from './dialog-ref';

const /** @type {?} */ BASKET_GROUP = {};
/**
 * A dumb stack implementation over an array.
 */
export class DialogRefStack<T> {
private _stack: DialogRef<T>[];
private _stackMap: Map<DialogRef<T>, any>;
/**
 * @return {?}
 */
get length(): number {
    return this._stack.length;
  }
constructor() {
    this._stack = [];
    this._stackMap = new Map<DialogRef<T>, any>();
  }
/**
 * @param {?} dialogRef
 * @param {?=} group
 * @return {?}
 */
push(dialogRef: DialogRef<T>, group?: any): void {
    if (this._stack.indexOf(dialogRef) === -1) {
      this._stack.push(dialogRef);
      this._stackMap.set(dialogRef, group || BASKET_GROUP);
    }
  }
/**
 * Push a DialogRef into the stack and manage it so when it's done
 * it will automatically kick itself out of the stack.
 * @param {?} dialogRef
 * @param {?=} group
 * @return {?}
 */
pushManaged(dialogRef: DialogRef<T>, group?: any): void {
    this.push(dialogRef, group);
    dialogRef.onDestroy.subscribe(() => this.remove(dialogRef));
  }
/**
 * @return {?}
 */
pop(): DialogRef<T> {
    const /** @type {?} */ dialogRef = this._stack.pop();
    this._stackMap.delete(dialogRef);
    return dialogRef;
  }
/**
 * Remove a DialogRef from the stack.
 * @param {?} dialogRef
 * @return {?}
 */
remove(dialogRef: DialogRef<T>): void {
    let /** @type {?} */ idx = this.indexOf(dialogRef);
    if (idx > -1) {
      this._stack.splice(idx, 1);
      this._stackMap.delete(dialogRef);
    }
  }
/**
 * @param {?} index
 * @return {?}
 */
index(index: number): DialogRef<T> {
    return this._stack[index];
  }
/**
 * @param {?} dialogRef
 * @return {?}
 */
indexOf(dialogRef: DialogRef<T>): number {
     return this._stack.indexOf(dialogRef);
  }
/**
 * @param {?} dialogRef
 * @return {?}
 */
groupOf(dialogRef: DialogRef<T>): any {
    return this._stackMap.get(dialogRef);
  }
/**
 * @param {?} group
 * @return {?}
 */
groupBy(group: any): DialogRef<T>[] {
    let /** @type {?} */ arr = [];
    if (group) {
      this._stackMap.forEach( (value, key) => {
        if (value === group) {
          arr.push(key);
        }
      });
    }
    return arr;
  }
/**
 * @param {?} group
 * @return {?}
 */
groupLength(group: any): number {
    let /** @type {?} */ count = 0;
    if (group) {
      this._stackMap.forEach( (value, key) => {
        if (value === group) {
          count++;
        }
      });
    }
    return count;
  }
}

function DialogRefStack_tsickle_Closure_declarations() {
/** @type {?} */
DialogRefStack.prototype._stack;
/** @type {?} */
DialogRefStack.prototype._stackMap;
}

